import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=1b86b691&"
import script from "./welcome.js?vue&type=script&lang=js&"
export * from "./welcome.js?vue&type=script&lang=js&"
import style0 from "./welcome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports